import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import MainLayout from '../../core/components/layout/MainLayout';
import { useAuth } from '../../features/auth/hooks/useAuth';

interface ProtectedRouteProps {
  redirectTo?: string;
  children?: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ redirectTo = '/auth', children }) => {
  const { isAuthenticated, token } = useAuth();
  const location = useLocation();

  if (!isAuthenticated || !token) {
    return <Navigate to={redirectTo} state={{ from: location.pathname }} replace />;
  }

  // if (isLoadingProfile) {
  //   return <PageSkeleton />;
  // }
  return <MainLayout>{children ? children : <Outlet />}</MainLayout>;
};

export default ProtectedRoute;